export class TimetableRouteMapping {
  /**
   * timetable id
   */
  id: Number;

  /**
   * timetableId
   */
  timetableId: Number;

  /**
   * display
   */
  display: Number;

  /**
   * routeMapping
   */
  routeMapping: string;
}
